import type { VehicleBidding, VehicleData } from 'Pages/vehicles/helpers/vehicle.schema';

export interface LegacyVehicleForPermitCheckerAndPurchaseModalContent {
	bids: VehicleBidding['legacyBids'];
	displayPrice: VehicleBidding['displayPrice']['value'];
	hasOtherContactActiveBid: VehicleBidding['hasOtherContactActiveBid'];
	highestBid?: NonNullable<VehicleBidding['highestBidOrOffer']>['value'];
	id: VehicleData['id'];
	isOwnedByUserDealership: VehicleBidding['isOwnedByUserDealership'];
	isVatQualifying: VehicleBidding['isVatQualifying'];
	minimumBid: VehicleBidding['minimumBid'];
	prettyVrm: VehicleBidding['prettyVrm'];
	sellerWillAcceptPrice: VehicleBidding['priceReserve']['value'];
	soldFor: VehicleBidding['soldFor'];
	sourcePartner: VehicleData['sourcePartner'];
	spec: VehicleBidding['spec'];
	state: VehicleData['state'];
	vrm: VehicleBidding['vrm'];
}

interface MapBiddingValuesToLegacyVehicleParams {
	biddingVehicleValues: VehicleBidding;
	id: VehicleData['id'];
	sourcePartner: VehicleData['sourcePartner'];
	state: VehicleData['state'];
}

// This is needed to allow for permit checker use and the existing purchase modal content
export const mapBiddingValuesToLegacyVehicle = ({
	biddingVehicleValues,
	id,
	sourcePartner,
	state,
}: MapBiddingValuesToLegacyVehicleParams): LegacyVehicleForPermitCheckerAndPurchaseModalContent => {
	const {
		displayPrice,
		hasOtherContactActiveBid,
		highestBidOrOffer,
		isOwnedByUserDealership,
		isVatQualifying,
		legacyBids,
		minimumBid,
		prettyVrm,
		priceReserve,
		soldFor,
		spec,
		vrm,
	} = biddingVehicleValues;

	return {
		bids: legacyBids,
		displayPrice: displayPrice.value,
		hasOtherContactActiveBid,
		highestBid: highestBidOrOffer?.value,
		id,
		isOwnedByUserDealership,
		isVatQualifying,
		minimumBid,
		prettyVrm,
		sellerWillAcceptPrice: priceReserve.value,
		soldFor,
		sourcePartner,
		spec,
		state,
		vrm,
	};
};
